import React, { useState } from 'react';

import { useHistory } from 'react-router-dom';

import { ClickAwayListener } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputBase from '@material-ui/core/InputBase';

import { ProductTelemetryController } from '../product-telemetry/product-telemetry-controller';
import { applicantDirectoryRoute } from '../web-routes';

import { ICON_NAMES, MaterialDesignIcon } from '../util/material-design-icons';
import { trackWithSmartlook } from '../util/track-with-smartlook';

export const ApplicantSearch = ({ path }: { path: string }) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [focus, setFocus] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(false);
  const history = useHistory();

  const updateSearch = (e: React.ChangeEvent<{ value: string }>) => {
    setSearchTerm(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const smartlookEventInformation = {
      eventName: 'Applicant Search Submit',
      props: { filterByNameOrPhoneNumber: searchTerm },
    };

    trackWithSmartlook(smartlookEventInformation, 'Applicant hit enter without search term');
    ProductTelemetryController.logEvent('applicant search submitted', { value: searchTerm });

    history.push(
      applicantDirectoryRoute({
        previousLocationPath: path,
        filterByNameOrPhoneNumber: searchTerm || undefined,
      }),
    );
  };

  const handleFocus = () => setFocus(true);

  const handleBlur = () => {
    setTimeout(() => {
      setSearchTerm('');
      setFocus(false);
    }, 300);
  };

  const handleSetIsExpanded = (isExpanded: boolean) => () => {
    setExpanded(isExpanded);
  };

  return (
    <ClickAwayListener onClickAway={handleSetIsExpanded(false)}>
      <form onSubmit={handleSubmit} onFocus={handleFocus} onBlur={handleBlur} className="u-spread">
        {expanded ? (
          <div className="u-cursor-pointer u-spread u-padding-lg">
            <InputBase
              value={searchTerm}
              className="u-color-white u-border u-borderRadius-15 u-padding-x-sm"
              onChange={updateSearch}
              placeholder="Search Applicants"
              startAdornment={
                <InputAdornment position="start">
                  <MaterialDesignIcon iconName={ICON_NAMES.SEARCH} size="sm" />
                </InputAdornment>
              }
              autoFocus
            />
            <IconButton
              type="submit"
              aria-label="search"
              className={`u-float-right u-color-white ${focus ? '' : 'u-display-none'}`}
              size="small"
            >
              <MaterialDesignIcon iconName={ICON_NAMES.ARROW_FORWARD} size="sm" />
            </IconButton>
          </div>
        ) : (
          <div className="u-hover-highlight">
            <IconButton
              onClick={handleSetIsExpanded(true)}
              className="u-backgroundHover-transparent u-cursor-pointer u-spread u-padding-lg"
              size="small"
            >
              <MaterialDesignIcon
                iconName={ICON_NAMES.SEARCH}
                color="white"
                className="u-margin-sm"
                size="lg"
              />
            </IconButton>
          </div>
        )}
      </form>
    </ClickAwayListener>
  );
};
